import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

export default function BasicTable({ rows = [] }) {
  function createData({ created_ip_address, last_login_ip_address, platform }) {
    return {
      createdIpAddress: created_ip_address,
      lastLoginIpAddress: last_login_ip_address,
      platform,
    };
  }

  const mappedData = rows.map((row) => createData(row));

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Created Ip Address</TableCell>
            <TableCell align="right">Last Login Ip Address</TableCell>
            <TableCell align="right">platform</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {mappedData.map((row) => (
            <TableRow
              key={row.name}
              sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {row.createdIpAddress}
              </TableCell>
              <TableCell align="right">{row.lastLoginIpAddress}</TableCell>
              <TableCell align="right">{row.platform}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
